import request from '@/utils/request'

// 公用actions
const actions = {
  async initEnum({ commit }) {
    const { data } = await request({
      url: '/api-pms-order/api/common/v2/options/queryAll',
      method: 'post',
    })

    commit('SET_ENUM', data)
  },
}
export default actions
